import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import db from "../db";
import CategoryLists from "../components/CategoryLists";
 import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

const EditCategory = () => {
  const { categoryId } = useParams();
  const [newName, setNewName] = useState("");
  const [parentCategories, setParentCategories] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [newParentId, setNewParentId] = useState("");
  const navigate = useNavigate();
  const [userAddedCategories, setUserAddedCategories] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const loadCategory = useCallback(async () => {
    const categoryFromDB = await db.categories.get(Number(categoryId));

    setNewName(categoryFromDB.name);
    setNewParentId(categoryFromDB.parentId || "");
  }, [categoryId, setNewName, setNewParentId]);

  const loadParentCategories = useCallback(async () => {
    const parentCategoriesFromDB = await db.categories.toArray();
    setParentCategories(parentCategoriesFromDB);
  }, [setParentCategories]);

  useEffect(() => {
    loadCategory();
    loadParentCategories();
  }, [loadCategory, loadParentCategories]);

  const handleEditCategory = async () => {
    await db.categories.update(Number(categoryId), {
      name: newName,
      parentId: newParentId !== "" ? Number(newParentId) : null,
      isEdited: 1,
    });
    setMessage("Successfully updated");
    setMessageType("success");
    startCountdown();
    setTimeout(() => navigate(-1), 1000);
  };

  useEffect(() => {
    const fetchUserAddedCategories = async () => {
      try {
        const categoriesFromDB = await db.categories.toArray();
        setUserAddedCategories(categoriesFromDB);
      } catch (error) {
        console.error("Error fetching user-added categories:", error);
      }
    };
    fetchUserAddedCategories();
  }, []);

  const [intervalId, setIntervalId] = useState(null);

  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  return (
    <div className="container main-div p-2  ">
      <div className="display-center pb-4">
        <button
          className="btn verticalAlign position-absolute start-0 "
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="fs-1  material-symbols-outlined">
            chevron_backward
          </span>
        </button>
        <h3 className=" verticalAlign heading-txt">Update Category</h3>
      </div>

      <div className=" card child-div  ">
        <div className="row ">
          <div className=" col-lg-6 col-md-6 col-sm-12 mb-2">
            <label className=" pb-2" htmlFor="name">
              Category
            </label>
            <input
              type="text"
              id="name"
              className="mb-4 form-control"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
            <label className=" pb-2" htmlFor="parentId">
              Parent Category
            </label>
            <CategoryLists
              categories={parentCategories}
              selectedParent={userAddedCategories.find(
                (c) => c.id === Number(newParentId)
              )}
              onChange={(e) => setNewParentId(e.target.value)}
            />
          </div>
        </div>
        <div className="pt-5 pb-4 display-center">
          <button
            className="save-btn rounded-pill"
            onClick={handleEditCategory}
          >
            <span className="material-symbols-outlined verticalAlign me-2">
              save
            </span>
            <span className="verticalAlign">Save</span>
          </button>
        </div>
        <ErrorSuccessMessage
          message={message}
          messageType={messageType}
          isActive={isActive}
          progress={progress}
        />
      </div>
    </div>
  );
};

export default EditCategory;
